import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'talent_analytics',
  children: {
    headcount: {
      path: 'headcount',
    },
    performance: {
      path: 'performance',
    },
    nineBoxGrid: {
      path: 'nine_box_grid',
    },
    pulseSurvey: {
      path: 'pulse_survey',
    },
  },
} as const satisfies Location
